const parsePositiveNumber = (value: string | number | null | undefined) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : undefined;
};

export const areCurrencyCodesEqual = (left?: string | null, right?: string | null) =>
  Boolean(left && right && left.toUpperCase() === right.toUpperCase());

export const formatFxRate = (value: string | number, locale: string) =>
  new Intl.NumberFormat(locale, {
    maximumFractionDigits: 6,
  }).format(Number(value));

interface RefundEstimateAvailabilityParams {
  orderFiatCurrencyCode?: string | null;
  reserveFiatCurrencyCode?: string;
  settlementCurrencyCode?: string;
  displayFxRate?: string | null;
  isLoading: boolean;
  isError: boolean;
}

export const getRefundEstimateAvailability = ({
  orderFiatCurrencyCode,
  reserveFiatCurrencyCode,
  settlementCurrencyCode,
  displayFxRate,
  isLoading,
  isError,
}: RefundEstimateAvailabilityParams) => {
  const isNonUsdOrder = !areCurrencyCodesEqual(orderFiatCurrencyCode, 'USD');
  const isReserveCurrencyMatch = areCurrencyCodesEqual(reserveFiatCurrencyCode, orderFiatCurrencyCode);
  const compatibleDisplayFxRate = isReserveCurrencyMatch ? displayFxRate : undefined;

  return {
    displayFxRate: compatibleDisplayFxRate,
    isLoading: isNonUsdOrder && isLoading,
    isUnavailable:
      isNonUsdOrder && !isLoading && (isError || !isReserveCurrencyMatch || !compatibleDisplayFxRate || !settlementCurrencyCode),
  };
};

export const MIN_REFUND_SETTLEMENT_AMOUNT = 1;

export const calculateRefundSettlementEstimate = (
  fiatAmount: string | number | null | undefined,
  displayFxRate: string | number | null | undefined,
) => {
  const amount = parsePositiveNumber(fiatAmount);
  const rate = parsePositiveNumber(displayFxRate);

  if (!amount || !rate) {
    return undefined;
  }

  return Math.ceil((amount / rate) * 100) / 100;
};

export const isRefundSettlementBelowMinimum = (settlementAmount: number | undefined) =>
  settlementAmount != null && settlementAmount < MIN_REFUND_SETTLEMENT_AMOUNT;

export const calculateFiatEstimate = (
  settlementAmount: string | number | null | undefined,
  displayFxRate: string | number | null | undefined,
) => {
  const amount = parsePositiveNumber(settlementAmount);
  const rate = parsePositiveNumber(displayFxRate);

  if (!amount || !rate) {
    return undefined;
  }

  return amount * rate;
};
